// extracted by mini-css-extract-plugin
export default {"blinking":"SLA_Timer_blinking__Y97nM","blink":"SLA_Timer_blink__ZQ5QB"};